import axios from "axios";
import * as actions from "./actionsTypes";
import messages from "../../messages";
import toastr from "toastr";
import MantIndikServices from "./mantIndk.services";

export const getMantIndks = filters => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADER_MANT_INDKS,
      payload: true,
    });
    const resp = await MantIndikServices.getMantIndiks(filters);
    dispatch({
      type: actions.GET_MANT_INDKS,
      payload: resp.data,
    });
    dispatch({
      type: actions.MANT_INDK_FAILS,
      payload: null,
    });
    dispatch({
      type: actions.FORM_MANT_INDK_FAIL,
      payload: null,
    });
    // toastr.success(messages.successMessage, '', {
    //   progressBar: true,
    //   rtl: true,
    // });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if(ex.response.data && ex.response.data.mensaje){
              message = ex.response.data.mensaje;
            }else{
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      }else{
        message = messages.networkError;
      }
    }else{
      message = messages.applicationError
    }
    dispatch({
      type: actions.MANT_INDK_FAILS,
      payload: message
    })
  }finally {
    dispatch({
      type: actions.LOADER_MANT_INDKS,
      payload: false,
    });
  }
}

export const getMantIndk = id => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADER_MANT_INDK,
      payload: true,
    });
    const resp = await MantIndikServices.getMantIndik(id);
    dispatch({
      type: actions.GET_MANT_INDK,
      payload: resp.data,
    });
    dispatch({
      type: actions.MANT_INDK_FAIL,
      payload: null,
    });
    // toastr.success(messages.successMessage, '', {
    //   progressBar: true,
    //   rtl: true,
    // });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            message = messages.notFound;
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      }else{
        message = messages.networkError;
      }
    }else{
      message = messages.applicationError
    }
    dispatch({
      type: actions.MANT_INDK_FAIL,
      payload: message
    })
  }finally {
    dispatch({
      type: actions.LOADER_MANT_INDK,
      payload: false,
    });
  }
}

export const saveMantIndik = (req, setShowModal) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADER_MANT_INDK,
      payload: true,
    });
    debugger;
    const resp = await MantIndikServices.saveMantIndik(req);
    const { mantIndks } = getState().mantIndk;
    
    dispatch({
      type: actions.GET_MANT_INDKS,
      payload: {
        count: mantIndks.count + 1,
        data: [...mantIndks.data, resp.data]
      },
    });

    dispatch({
      type: actions.FORM_MANT_INDK_FAIL,
      payload: null,
    });

    toastr.success(messages.successMessage, '', {
      progressBar: true,
      rtl: true,
    });

    setShowModal(false);

  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data;
            break;
          case 404:
            if(ex.response.data && ex.response.data.mensaje){
              message = ex.response.data.mensaje;
            }else{
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      }else{
        message = messages.networkError;
      }
    }else{
      message = messages.applicationError
    }
    dispatch({
      type: actions.FORM_MANT_INDK_FAIL,
      payload: message
    })
  }finally {
    dispatch({
      type: actions.SAVE_LOADER_MANT_INDK,
      payload: false,
    });
  }
}

export const editMantIndik = (req, index, setShowModal) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADER_MANT_INDK,
      payload: true,
    });
    const resp = await MantIndikServices.editMantIndik(req.id, req);
    const { mantIndks } = getState().mantIndk;
    let _mantIndks = mantIndks.data.slice();
    _mantIndks[index] = resp.data;
    dispatch({
      type: actions.GET_MANT_INDKS,
      payload: {
        count: mantIndks.count,
        data: _mantIndks
      },
    });
    dispatch({
      type: actions.FORM_MANT_INDK_FAIL,
      payload: null,
    });
    toastr.success(messages.successMessage, '', {
      progressBar: true,
      rtl: true,
    });
    setShowModal(false);

  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data;
            break;
          case 404:
            if(ex.response.data && ex.response.data.mensaje){
              message = ex.response.data.mensaje;
            }else{
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      }else{
        message = messages.networkError;
      }
    }else{
      message = messages.applicationError
    }
    dispatch({
      type: actions.FORM_MANT_INDK_FAIL,
      payload: message
    })
  }finally {
    dispatch({
      type: actions.SAVE_LOADER_MANT_INDK,
      payload: false,
    });
  }
}

export const deleteMantIndik = (id, index) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADER_MANT_INDKS,
      payload: true,
    });
    await MantIndikServices.deleteMantIndik(id);
    const { mantIndks } = getState().mantIndk;
    let _mantIndks = mantIndks.data.slice();
    _mantIndks.splice(index, 1);
    dispatch({
      type: actions.GET_MANT_INDKS,
      payload: {
        data: _mantIndks,
        count: mantIndks.count - 1
      }
    });
    dispatch({
      type: actions.MANT_INDK_FAILS,
      payload: null,
    });
    toastr.success(messages.successMessage, '', {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            message = messages.notFound;
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      }else{
        message = messages.networkError;
      }
    }else{
      message = messages.applicationError
    }
    dispatch({
      type: actions.MANT_INDK_FAILS,
      payload: message
    })
  }finally {
    dispatch({
      type: actions.LOADER_MANT_INDKS,
      payload: false,
    });
  }
}